/**
 * @fileoverview POST handler for the "/internal_user_groups/internal_user_group_create" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { internalUserGroupsInternalUserGroupCreateCacheKeys } from "./constants";
import type {
  InternalUserGroupsInternalUserGroupCreateResult,
  AppSettingsInternalUserGroupsInternalUserGroupCreateOptions,
} from "./types";

const nestedPropertyData = (
  propertyData: string,
  isEnabled: boolean,
  isDefault?: boolean
): Record<string, { is_enabled: boolean; is_default?: boolean }> => {
  if (isDefault === undefined) {
    return { [propertyData]: { is_enabled: !!isEnabled } };
  }

  return { [propertyData]: { is_enabled: !!isEnabled, is_default: !!isDefault } };
};

export const postAppSettingsInternalUserGroupsInternalUserGroupCreate = reactQueryMutationAdapter(
  internalUserGroupsInternalUserGroupCreateCacheKeys,
  ({
    appGroupId,
    name,
    isEnabledUserEventLog,
    isEnabledContentTest,
    isDefaultContentTest,
    isEnabledSeedGroup,
    isDefaultSeedGroup,
    territoryId,
  }: AppSettingsInternalUserGroupsInternalUserGroupCreateOptions): Promise<InternalUserGroupsInternalUserGroupCreateResult> => {
    const body = {
      name,
      ...(territoryId ? { territory_ids: [territoryId] } : {}),
      ...nestedPropertyData("user_event_log", isEnabledUserEventLog),
      ...nestedPropertyData("content_test", isEnabledContentTest, isDefaultContentTest),
      ...nestedPropertyData("seed_group", isEnabledSeedGroup, isDefaultSeedGroup),
    };

    return fetch(
      `/internal_user_groups/internal_user_group_create?app_group_id=${appGroupId}`,
      "POST",
      body,
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
